export default {"src":"/_next/static/media/refresh-line.e823cd5e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};